import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseControlValueAccessor } from 'rev-shared/util/BaseControlValueAccessor';

import { IEmbeddedContentLink } from './EmbeddedContentTypes';

import styles from './EmbeddedContentEntry.Component.module.less';

@Component({
	selector: 'embedded-content-entry',
	templateUrl: './EmbeddedContentEntry.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => EmbeddedContentEntryComponent),
		multi: true
	}],
	standalone: false
})
export class EmbeddedContentEntryComponent extends BaseControlValueAccessor<IEmbeddedContentLink> {
	@Input() public showToggleBtn = false;
	@Input() public showPreviewBtn = false;
	@Input() public showEditDeleteBtns = false;
	@Output() public editEntry: EventEmitter<void> = new EventEmitter();
	@Output() public updateEntry: EventEmitter<void> = new EventEmitter();
	@Output() public deleteEntry: EventEmitter<void> = new EventEmitter();

	public readonly styles = styles;

	constructor() {
		super();
	}

	public onEnabledToggleClick(): void {
		this.updateEntry.emit();
	}

	public onEditClick(): void {
		this.editEntry.emit();
	}

	public onDeleteClick(): void {
		this.deleteEntry.emit();
	}

	public onPreviewClick(): void {
		const popupCfg = 'toolbar=no,location=no,status=no,menubar=no';
		const width = 400;
		const height = 1000;
		const screen: any = window.screen;
		const left = (window.screenLeft ?? screen.left ?? screen.availLeft ?? 0) + (screen.availWidth - width) / 2;
		const top = (window.screenTop ?? screen.top ?? screen.availTop ?? 0) + (screen.availHeight - height) / 2;

		window.open(this.value.resourceUri, '_blank', `${popupCfg},width=${width}, height=${height}, top=${top}, left=${left}`);
	}

}
